export default __webpack_public_path__ + "static/media/highlight-4-new.18d78baa.jpg";